import React, { useState } from 'react';
import { Row } from 'antd';
import { CopyFilled } from '@ant-design/icons';

import * as S from './styles';

export function Text({
  title,
  value,
  titlesize,
  valuesize,
  color,
  width = '',
}) {
  const [copyableItem, setCopyableItem] = useState(false);
  return (
    <S.TextCard width={width}>
      <S.Title titlesize={titlesize} strong>
        {title || ''}
      </S.Title>
      <Row
        onMouseOver={() => setCopyableItem(true)}
        onMouseLeave={() => setCopyableItem(false)}
        style={{
          display: 'flex',
          flexWrap: 'nowrap',
          alignItems: 'center',
          margin: '0px'
        }}
      >
        {copyableItem && (
          <S.ValueTextCopyable
            copyable={{
              text: value,
              icon: [
                <CopyFilled
                  style={{
                    color: '#24A95D',
                  }}
                />,
              ],
            }}
          />
        )}
        <S.ValueText color={color} valuesize={valuesize}>
          {value || ''}
        </S.ValueText>
      </Row>
    </S.TextCard>
  );
}
